

export default function AdminHeader({ onMenuClick }) {
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-20">
      <div className="flex items-center justify-between px-4 md:px-6 lg:px-8 py-4">
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuClick}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900">Dashboard</h2>
            <p className="text-sm text-gray-500 hidden md:block">Welcome back, Admin</p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <button className="w-10 h-10 flex items-center justify-center text-gray-700 hover:bg-gray-100 rounded-lg transition-colors relative cursor-pointer">
            <i className="ri-notification-3-line text-xl"></i>
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-lilac-400 rounded-full"></span>
          </button>

          <div className="flex items-center space-x-3 pl-3 border-l border-gray-200">
            <div className="hidden md:block text-right">
              <p className="text-sm font-medium text-gray-900">Admin User</p>
              <p className="text-xs text-gray-500">admin@sisi.com</p>
            </div>
            <div className="w-10 h-10 bg-lilac-400 rounded-full flex items-center justify-center cursor-pointer">
              <i className="ri-user-line text-white text-lg"></i>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
